import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer__box" }
const _hoisted_3 = { class: "container-custom" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-12 col-lg-6" }
const _hoisted_6 = { class: "footer__box-item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/images/layouts/logo.svg",
  alt: ""
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "item__text" }, "Subscribe to the Newsletter", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "item__input" }, [
  /*#__PURE__*/_createElementVNode("input", { type: "text" }),
  /*#__PURE__*/_createElementVNode("div", { class: "item__input-button" }, "Send")
], -1)
const _hoisted_11 = { class: "col-12 col-md-6 col-lg-3" }
const _hoisted_12 = { class: "footer__box-item" }
const _hoisted_13 = { class: "item__link" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"col-12 col-md-6 col-lg-3\"><div class=\"footer__box-item\"><div class=\"item__social\"><div class=\"item__social-title\">Contact Us</div><div class=\"item__social-link\"><a href=\"javascript:;\"><img src=\"/assets/images/icons/icon-google.svg\" alt=\"\"></a><a href=\"javascript:;\"><img src=\"/assets/images/icons/icon-x.svg\" alt=\"\"></a><a href=\"javascript:;\"><img src=\"/assets/images/icons/icon-telegram.svg\" alt=\"\"></a></div></div></div></div>", 1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "footer__copyright" }, [
  /*#__PURE__*/_createElementVNode("span", null, "© Copyright SSI Digital")
], -1)

import router from '@/router'
import { scrollToElement } from '@/utils/util'
import { reactive } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const state = reactive({
  listMenu: [
    { title: 'Venture Builder', link: 'venture' },
    { title: 'VB Model', link: 'model' },
    { title: 'We work', link: 'work' },
    { title: 'Contact', link: 'contact' },
  ]
})

const handleClick = (link: string) => {
  router.replace({ name: 'Home', params: { id: link } })
  scrollToElement(link)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("a", {
                href: "javascript:;",
                class: "item__logo",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClick('home')))
              }, _hoisted_8),
              _hoisted_9,
              _hoisted_10
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.listMenu, (item, index) => {
                  return (_openBlock(), _createElementBlock("a", {
                    key: index,
                    href: "javascript:;",
                    onClick: ($event: any) => (handleClick(item.link))
                  }, _toDisplayString(item.title), 9, _hoisted_14))
                }), 128))
              ])
            ])
          ]),
          _hoisted_15
        ])
      ])
    ]),
    _hoisted_16
  ]))
}
}

})